export const ABOUT_CATEGORY = "SOBRE MIM";

export const portfolioData = {
  profile: {
    name: "Raquel Quirino",
    title: "Game developer, game designer e pixel artist.",
    subtitle: "Estudante de Ciência da Computação na Unifor, com foco em jogos e experiências XR.",
  },

  categories: {
    [ABOUT_CATEGORY]: [
      {
        id: 1,
        isAbout: true,
        title: "Sobre mim",
        tags: []
      },
      {
        id: 2,
        title: "Raquel Albuquerque Quirino",
        tags: [],
        images: [
          "/sobremim_images/raquel_albuquerque_quirino.jpg"
        ],
        description: `
          <p>Sou estudante de Ciência da Computação na Universidade de Fortaleza (Unifor) e venho construindo minha trajetória na criação de jogos e experiências interativas. Tenho especial interesse em Game Design, Unity, pixel art e tecnologias imersivas, participando desde a concepção de ideias e mecânicas até a prototipação e implementação.</p>

          <p>O que mais me atrai em jogos é a possibilidade de criar experiências marcantes, seja por meio de histórias que permaneçam com o jogador, mecânicas divertidas e inesperadas ou novas formas de interação. Gosto especialmente de projetos que buscam causar algum tipo de impacto, explorando ideias diferentes e usando narrativa, sistemas e mecânicas de forma integrada.</p>

          <p>Ao longo dos meus projetos, tenho buscado justamente unir criatividade e conhecimento técnico para transformar conceitos em experiências envolventes, com identidade própria e propósito.</p>
        `
      },
      {
        id: 3,
        title: "Formação acadêmica e pesquisa",
        tags: [],
        images: [
          "/sobremim_images/gadget_apresentação.jpg",
          "/sobremim_images/gamejam_ZERO.jpg",
          "/sobremim_images/gamejam_ZERO_1.jpg"
        ],
        description: `
          <p>Sou estudante de Ciência da Computação na Universidade de Fortaleza (Unifor), desde 2023, com uma trajetória voltada ao desenvolvimento de jogos, Unity, realidade virtual e aumentada, software interativo e pesquisa aplicada. Ao longo da graduação, tenho buscado aproximar a formação técnica em computação de projetos ligados à criação de experiências interativas para educação, cultura e treinamento.</p>

          <p>Também participo da produção científica como coautora de short papers relacionados a jogos, realidade virtual, educação médica e patrimônio cultural, com trabalhos vinculados a eventos como SBGames e SEGAH. Essa experiência contribuiu para o desenvolvimento de competências em documentação, escrita científica, prototipação e comunicação de resultados.</p>

          <p>Além disso, atuei como organizadora do GADGET, grupo de aprendizagem e desenvolvimento de games da Unifor, contribuindo para a promoção da comunidade, a organização da Game Jam ZERO e a participação em eventos como a Feira do Conhecimento e o Dia T da Unifor, com demonstração de jogos desenvolvidos em game jams.</p>
        `
      },
      {
        id: 4,
        title: "Experiência profissional",
        tags: [],
        images: [
          "/sobremim_images/vortex.jpg",
          "/orbita_capacita_1.jpg",
          "/sobremim_images/brasilia_gamefestival.jpg",
        ],
        description: `
          <p><strong>Laboratório VÓRTEX da Universidade de Fortaleza (Unifor).</strong> Iniciei no laboratório como voluntária e depois passei a atuar como estagiária, participando da criação de jogos e experiências interativas em Unity. Minha atuação envolve concepção de mecânicas, estruturação de fluxos, narrativa, interação e experiência do usuário, além de prototipação, testes e refinamento em equipes multidisciplinares. Entre os projetos desenvolvidos estão o MedSim, voltado ao treinamento clínico em VR, e o Cascavel, uma experiência narrativa imersiva inspirada em patrimônio cultural e literatura de cordel.</p>

          <p><strong>Órbita Capacita: Founder &amp; CTO.</strong> Sou cofundadora e CTO da Órbita Capacita, uma iniciativa de treinamento corporativo em realidade virtual. Além da liderança tecnológica, atuo diretamente na concepção das experiências de treinamento, transformando necessidades técnicas em fluxos, interações e propostas imersivas mais claras e envolventes. Participo da definição das mecânicas, da experiência do usuário, da estrutura dos cenários e das decisões de produto, conectando Game Design, VR e desenvolvimento em Unity.</p>

          <p><strong>Game jams e projetos autorais.</strong> Participo regularmente de game jams e projetos independentes, atuando principalmente em Game Design, narrativa, ideação, sistemas e pixel art. Esses projetos me deram experiência prática em transformar conceitos em experiências jogáveis, definir escopo, criar mecânicas e iterar rapidamente em ciclos curtos de produção.</p>
        `
      },
      {
        id: 5,
        title: "Destaques e reconhecimentos",
        tags: [],
        images: [
          "/orbita_capacita_2.jpg",
          "/sobremim_images/gamejam_premiacao_8.jpeg",
          "/sobremim_images/gamejam_premiacao_9.jpeg",
          "/sobremim_images/segundomelhorjogo_gamejam.jpeg",
          "/sobremim_images/premios_gamejam.jpeg",
        ],
        description: `
          <p><strong>07 prêmios com Still Me.</strong> 2º Melhor Jogo do Brasil na Game Jam+, melhor universidade, melhor equipe diversa, prêmio de narrativa e outros reconhecimentos.</p>

          <p><strong>SEGAH &amp; SBGames.</strong> Participação em produção científica com short papers vinculados a jogos, VR, educação médica e patrimônio cultural.</p>

          <p><strong>3º lugar no Hackathon Proenergia Summit 2025.</strong> Reconhecimento conquistado com o projeto Órbita Capacita.</p>

          <p><strong>Programa Centelha.</strong> Projeto contemplado em iniciativa de incentivo à inovação.</p>

          <p><strong>Na mídia:</strong></p>
          <ul>
            <li><a href="https://unifor.br/web/pesquisa-inovacao/-/equipe-da-unifor-conquista-premios-na-game-jam-final-global" target="_blank" rel="noreferrer">Equipe da Unifor conquista prêmios na Game Jam+ final global</a></li>
            <li><a href="https://unifor.br/web/pesquisa-inovacao/-/orgulho-unifor-equipe-do-vortex-avanca-em-competicao-internacional-de-criacao-de-jogos" target="_blank" rel="noreferrer">Orgulho Unifor: equipe do Vórtex avança em competição internacional de criação de jogos</a></li>
            <li><a href="https://unifor.br/web/pesquisa-inovacao/-/tec-unifor-conquista-triplo-podio-hackathon-proenergia-summit-2025" target="_blank" rel="noreferrer">Tec Unifor conquista triplo pódio no Hackathon Proenergia Summit 2025</a></li>
          </ul>
        `
      }
    ],

    "JOGOS & XR": [
      {
        id: 1,
        title: "MedSim",
        tags: ["Unity", "VR", "Serious Game", "Game Design"],
        videoUrl: "vcza0sSFXx0",
        images: [
          "/medsim_anam.jpg",
          "/medsim_exam.jpg",
          "/medsim_diag.jpg"
        ],
        description: `
          <p><strong>MedSim</strong> é uma plataforma de realidade virtual para treinamento e avaliação do raciocínio clínico. A experiência simula um atendimento estruturado em quatro etapas: <strong>anamnese, exame físico, solicitação de exames e diagnóstico</strong>.</p>

          <p>Durante a simulação, o estudante conversa com o paciente, utiliza instrumentos médicos, solicita exames laboratoriais e de imagem e toma uma decisão diagnóstica. Ao final, recebe pontuação e feedback sobre suas escolhas.</p>

          <p><strong>Minha contribuição:</strong> desenvolvimento em Unity/C#, estruturação de sistemas de interação VR e participação no game design da experiência, incluindo fluxo clínico, interfaces, feedback e arquitetura modular dos cenários.</p>

          <p>O projeto também originou um <strong>short paper aprovado e publicado no SEGAH</strong>.</p>
        `,
        technologies: [
          "c-sharp.svg",
          "unity.svg"
        ]
      },

      {
        id: 2,
        title: "Cascavel (EM DESENVOLVIMENTO)",
        tags: ["Unity", "VR", "Narrativa", "Voice Interaction"],
        videoUrl: "ZEFMcRLxhSU",
        images: [
          "/cascavel_2.jpeg",
          "/cascavel_3.jpeg",
          "/cascavel_4.jpeg"
        ],
        description: `
          <p>Experiência narrativa em realidade virtual desenvolvida durante meu estágio no laboratório de pesquisa <strong>Vortex</strong>, para o <strong>Complexo Cultural Yolanda de Queiroz</strong>.</p>

          <p>A experiência apresenta a história e a lenda da cidade de Cascavel por meio de uma narrativa inspirada na literatura de cordel.</p>

          <p><strong>Minha contribuição:</strong> estruturação da experiência com Timeline da Unity, integração de reconhecimento de voz online e offline e implementação de comportamentos de NPCs com NavMeshAgent, sincronizando animação, interação e progressão narrativa.</p>
        `,
        technologies: [
          "c-sharp.svg",
          "unity.svg"
        ]
      },

      {
        id: 3,
        title: "Orbis (EM DESENVOLVIMENTO)",
        tags: ["Jogo", "Mobile", "Unity", "Pixel Art"],
        imageUrl: "/orbis_1.png",
        images: [
          "/orbis_2.png",
          "/orbis_3.png"
        ],
        description: `
          <p><strong>Orbis</strong> é um jogo mobile de exploração do campus da <strong>Unifor</strong>, inspirado em experiências de localização.</p>

          <p>O jogador percorre o campus, registra animais por foto e desbloqueia variações conforme região e horário.</p>

          <p><strong>Minha contribuição:</strong> desenvolvimento end-to-end em Unity/C#, implementação das telas a partir do Figma, integração de login/cadastro, captura por foto, Dex, perfil, dashboard e conquistas.</p>

          <p>Também produzi e integrei sprites 2D/pixel art de animais.</p>
        `,
        technologies: [
          "c-sharp.svg",
          "unity.svg"
        ]
      },

      {
        id: 4,
        title: "Still Me",
        tags: ["Game Design", "Narrativa", "Pixel Art", "Unity"],
        videoUrl: "x1vMzpE4Ze8",
        images: [
          "/still_me_1.jpg",
          "/still_me_2.jpeg",
          "/still_me_3.jpeg"
        ],
        description: `
          <p><strong>Still Me</strong> é um jogo narrativo 2D que combina puzzles simbólicos, minigames e narrativa ambiental para retratar a jornada de Rafael após um acidente.</p>

          <p>A história se desenvolve ao longo de sete dias e transforma instabilidade, bloqueios e pequenas vitórias em interações de gameplay.</p>

          <p><strong>Minha contribuição:</strong> Game Designer, Game Director, Narrative Designer e Pixel Artist. Estruturei o GDD, o fluxo narrativo, as escolhas e finais, desenhei e organizei os minigames e produzi sprites para cenário, UI e gameplay.</p>

          <p>O projeto recebeu diversos prêmios na <strong>Game Jam+</strong>, incluindo <strong>2º Melhor Jogo do Brasil</strong> e reconhecimentos em narrativa, diversidade e Campus Mode.</p>
        `,
        technologies: [
          "unity.svg",
          "c-sharp.svg"
        ]
      },

      {
        id: 5,
        title: "Tails Through Time",
        tags: ["Game Design", "Narrativa", "Puzzle"],
        imageUrl: "/ttt_main.png",
        images: [
          "/ttt_1.jpeg",
          "/ttt_2.jpeg",
          "/ttt_4.jpeg"
        ],
        description: `
          <p>Jogo narrativo em que uma gata-mãe procura seus filhotes atravessando diferentes contextos históricos e culturais.</p>

          <p>O projeto combina <strong>exploração, puzzles e narrativa ambiental</strong> em fases inspiradas em diferentes períodos e tradições.</p>

          <p><strong>Minha contribuição:</strong> game design e narrativa, incluindo progressão por fases, personagens, estrutura de cenas e integração entre patrimônio cultural e gameplay.</p>

          <p>O projeto também originou um <strong>short paper acadêmico</strong>.</p>
        `,
        technologies: [
          "unity.svg",
          "c-sharp.svg"
        ]
      },

      {
        id: 6,
        title: "Órbita Capacita",
        tags: ["Unity", "VR", "Serious Game", "Treinamento"],
        imageUrl: "/orbita_capacita_2.jpg",
        images: [
          "/orbita_capacita_1.jpg",
          "/orbita_capacita_3.jpg"
        ],
        description: `
          <p>Plataforma de capacitação corporativa em realidade virtual voltada para treinamentos técnicos e de segurança, com cenários imersivos aplicáveis a NRs e ambientes industriais.</p>

          <p><strong>Minha contribuição:</strong> desenvolvimento em Unity/VR e participação na estruturação do produto e das experiências de treinamento.</p>

          <p>O projeto conquistou o <strong>3º lugar no Hackathon Proenergia Summit 2025</strong> e foi contemplado pelo <strong>Programa Centelha</strong>.</p>
        `,
        technologies: [
          "unity.svg",
          "c-sharp.svg"
        ]
      },

      {
        id: 7,
        title: "Biblioteca Virtual em Realidade Aumentada",
        tags: ["Unity", "AR", "Mobile", "Vuforia"],
        videoUrl: "Z_Lo_Uo-zJI",
        images: [
          "/bibli_virtual_1.jpg",
          "/bibli_virtual_2.jpg",
          "/bibli_virtual_3.jpg",
        ],
        description: `
          <p>Prova de conceito de baixo custo para ampliar o acesso tangível a acervos culturais digitalizados.</p>

          <p>Um livro físico funciona como interface para reconhecimento de páginas e exibição de representações digitais.</p>

          <p><strong>Minha contribuição:</strong> desenvolvimento da solução em Unity + Vuforia, integração de Image Targets, adaptação para Android e smartphone VR viewer e implementação do sistema de orientação por giroscópio.</p>

          <p>O projeto também foi desenvolvido como <strong>short paper acadêmico</strong>.</p>
        `,
        technologies: [
          "unity.svg"
        ]
      },

      {
        id: 8,
        title: "Swamp Vanquisher",
        tags: ["Jogo", "Web", "Game Design", "Pixel Art", "Strategy", "Game Jam"],
        videoUrl: "rj8NOCVryNQ",
        projectUrl: "https://raquelx99.itch.io/swamp-vanquisher",
        images: [
          "/swamp_1.jpg",
          "/swamp_2.jpeg",
          "/swamp_3.jpeg"
        ],
        description: `
          <p>Jogo de estratégia e conquista territorial em que o jogador controla um sapo aspirante a ditador do pântano.</p>

          <p>O núcleo do design está em equilibrar <strong>força e recrutamento</strong>: atacar reduz vida e moral rapidamente, enquanto persuadir preserva inimigos que podem se tornar aliados.</p>

          <p><strong>Minha contribuição:</strong> <strong>Game Designer e Pixel Art Artist</strong>. Trabalhei no loop de auto-battle, sistema de moral e persuasão, recrutamento, progressão territorial, governadores, classes e ultimates.</p>

          <p><a href="https://raquelx99.itch.io/swamp-vanquisher" target="_blank" rel="noreferrer">Jogar no itch.io</a></p>
        `,
        technologies: []
      },

      {
        id: 9,
        title: "I've Slept for 5 Hours and 59 Minutes... The GAME!",
        tags: ["Jogo", "3D", "Game Design", "Minigames", "Game Jam"],
        videoUrl: "gLmkoOZEWRw",
        projectUrl: "https://alyra004.itch.io/ive-slept-for-5-hours-and-59-minutes-of-my-6-hour-internship-and-now-i-have-60-s",
        images: [
          "/sleeping_at_work_1.jpeg",
          "/sleeping_at_work_2.jpeg",
          "/sleeping_at_work_3.jpeg"
        ],
        description: `
          <p>Jogo frenético de escritório em que o jogador tem apenas <strong>60 segundos</strong> para realizar uma sequência de tarefas por meio de minigames.</p>

          <p>A pressão de tempo e o caos das atividades cotidianas formam o núcleo da experiência.</p>

          <p><strong>Minha contribuição:</strong> <strong>Game Designer</strong>, trabalhando na estrutura do fluxo, no design das tarefas/minigames e no ritmo da experiência.</p>

          <p><a href="https://alyra004.itch.io/ive-slept-for-5-hours-and-59-minutes-of-my-6-hour-internship-and-now-i-have-60-s" target="_blank" rel="noreferrer">Jogar no itch.io</a></p>
        `,
        technologies: []
      },

      {
        id: 10,
        title: "Patowheel",
        tags: ["Unity", "UI", "C#"],
        description: `
          <p>Estudo prático de interfaces de usuário em <strong>Unity</strong>, desenvolvido para explorar design de UI, animações, responsividade, feedback visual e interação com elementos de gameplay.</p>

          <p><strong>Principais funcionalidades:</strong></p>
          <ul>
            <li>Roleta interativa utilizando física com Rigidbody2D.</li>
            <li>Animações, transições e feedback visual de UI.</li>
          </ul>
        `,
        technologies: [
          "c-sharp.svg",
          "unity.svg"
        ]
      },

      {
        id: 11,
        title: "Hades",
        tags: ["Unity", "VR", "Puzzle", "Narrativa"],
        description: `
          <p>Jogo de ficção científica com forte componente psicológico e uma mecânica central baseada na alternância entre duas realidades contrastantes: uma nave espacial futurística e uma casa antiga e abandonada.</p>

          <p>O jogador conecta pistas, memórias e puzzles entre os dois mundos para compreender uma catástrofe temporal, usando a troca de realidade como parte da progressão narrativa e mecânica.</p>
        `,
        technologies: [
          "c-sharp.svg",
          "unity.svg"
        ]
      }
    ],

    "SOFTWARE & APLICAÇÕES": [
      {
        id: 1,
        title: "O(fun). Porque O(n²) é passado!",
        tags: ["Java", "Java Swing", "Gamificação", "Algoritmos"],
        projectUrl: "https://github.com/raquelx99/O-fun",
        imageUrl: "/ofun_main.gif",
        images: [
          "/ofun_1.png",
          "/ofun_2.png",
          "/ofun_3.png"
        ],
        description: `
          <p><strong>O(fun)</strong> é uma aplicação educacional gamificada desenvolvida para a disciplina de Computação Paralela e Concorrente da Unifor. O projeto combina análise comparativa de algoritmos de ordenação com experiências interativas, permitindo explorar e comparar o desempenho de Bubble Sort, Insertion Sort, Quick Sort e Merge Sort em versões seriais e paralelas.</p>

          <p>Além de um laboratório de benchmarks e visualização de resultados, a aplicação possui dois modos gamificados: o <strong>Modo Desafio</strong>, no qual o jogador escolhe o algoritmo mais eficiente para diferentes cenários e acumula pontos, e o <strong>Modo Aprenda</strong>, que utiliza blocos interativos para ensinar os algoritmos, com desafios de ordenação manual e exercícios guiados com feedback imediato.</p>

          <p><a href="https://github.com/raquelx99/O-fun" target="_blank" rel="noreferrer">Ver repositório no GitHub</a></p>
        `,
        technologies: [
          "java.svg"
        ]
      },

      {
        id: 2,
        title: "Gestão Esportiva",
        tags: ["Web", "Full-stack", "Angular"],
        videoUrl: "ssPL3dwMH5U",
        images: [
          "/gestao_esportiva_1.jpg",
          "/gestao_esportiva_3.jpeg",
          "/gestao_esportiva_5.jpeg"
        ],
        description: `
          <p>Projeto desenvolvido para digitalizar e modernizar o gerenciamento de carteirinhas estudantis e o controle de uso dos espaços esportivos do ginásio.</p>

          <p>O sistema facilita a emissão da carteirinha digital, o acesso aos horários de quadras e a gestão dos horários pelos funcionários.</p>

          <p><strong>Funcionalidades principais:</strong></p>
          <ul>
            <li>Cadastro de estudantes e funcionários com perfis distintos.</li>
            <li>Geração de carteirinha digital com QR Code.</li>
            <li>Agendamento e visualização de horários das quadras.</li>
          </ul>
        `,
        technologies: [
          "angular.svg",
          "typescript.svg",
          "javascript.svg"
        ]
      },

      {
        id: 3,
        title: "Literati",
        tags: ["Mobile", "Back-end", "Kotlin", "Firebase"],
        videoUrl: "-9pHdaUPrLA",
        images: [
          "/literati_1.jpg",
          "/literati_2.jpg",
          "/literati_3.jpg"
        ],
        description: `
          <p>Desenvolvimento do sistema de comunidades para o app de livros <strong>Literati</strong>, integrado ao Firebase.</p>

          <ul>
            <li>Criação, exclusão e gerenciamento de comunidades.</li>
            <li>Posts com texto e imagem.</li>
            <li>Sistema de curtidas.</li>
            <li>Gestão de administradores e moderadores.</li>
            <li>Definição e atualização de imagens de capa.</li>
          </ul>
        `,
        technologies: [
          "kotlin.svg"
        ]
      }
    ]
  }
};